import { route } from "quasar/wrappers";
import {
  createRouter,
  createWebHistory,
  createMemoryHistory
} from "vue-router";
import { Cookies } from "quasar";
import routes from "./routes";
import { AppAuthTokenKey } from "@/libs/constant";
import { useCache } from "@/composables/useCache";

export default route(({ ssrContext }) => {
  const isServer = process.env.SERVER;
  const cookies = isServer ? Cookies.parseSSR(ssrContext) : Cookies;
  const { getUserFromCache } = useCache();

  const createHistory = isServer ? createMemoryHistory : createWebHistory;

  const Router = createRouter({
    scrollBehavior: (to, from, savedPosition) => {
      if (savedPosition) {
        return savedPosition;
      }
      return { left: 0, top: 0 };
    },
    routes,
    history: createHistory(process.env.VUE_ROUTER_BASE)
  });

  Router.beforeEach((to, from, next) => {
    const token = cookies.get(AppAuthTokenKey);
    const user = getUserFromCache();
    if (user && !user.setup_password && to.path !== "/auth/setup-password") {
      return next("/auth/setup-password");
    }
    if (token && to.meta.onlyGuest) {
      next("/");
    } else {
      next();
    }
  });

  return Router;
});
